import { Spinner } from 'react-bootstrap';

const Loader = () => (
  <div className="vh-100 d-flex align-items-center justify-content-center">
    <Spinner animation="border" />
  </div>
);

export default Loader;
